module.exports = __webpack_public_path__ + "static/media/W5390484_14.27a7c1a4.jpg";